import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { AwaitModules, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Recap } from '../../../modules/ModuleFE_Recap/ModuleFE_Recap.js';
import { exists } from '@nu-art/ts-common';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
import { FadeScrollWrapper, ICONS } from '@app/styles';
import './Dialog_Recap.scss';
import { EncounterFeedItem } from '../../../structs/EncounterFeedItem/EncounterFeedItem.js';
import { Component_EncounterFeed } from '../../components/encounter-feed/Component_EncounterFeed/Component_EncounterFeed.js';
import { Component_AdvisorSL_Recap } from '../../loaders/skeleton/catch-up/recap/Component_AdvisorSL_Recap.js';
export class Dialog_Recap extends ComponentSync {
    // ######################## Static ########################
    static dialogKey = 'dialog__recap';
    static show = () => {
        const advisorConfig = ModuleFE_AdvisorSession.getAdvisorConfig();
        const lastSeenTS = ModuleFE_AdvisorSession.lastSeenAt;
        if (!ModuleFE_AdvisorSession.hasRecapItems || !advisorConfig?.catchUp?.recap || !lastSeenTS?.previous)
            return ModuleFE_Recap.recapOnScreen = false;
        if (!exists(ModuleFE_Recap.recapOnScreen))
            ModuleFE_Recap.recapOnScreen = true;
        const model = {
            dialogKey: this.dialogKey,
            content: () => _jsx(Dialog_Recap, {}),
            overlayClass: 'dialog-overlay__recap',
            closeOverlayOnClick: () => false,
        };
        ModuleFE_Dialog.show(model);
    };
    static hide = () => {
        ModuleFE_Dialog.close(true, this.dialogKey);
        ModuleFE_Recap.recapOnScreen = false;
        ModuleFE_AdvisorAnalytics.trigger.recap.catchupRecap_dismissed();
    };
    // ######################## Logic ########################
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: Dialog_Recap.dialogKey, children: [this.render_Header(), this.render_Body()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'recap__header', children: [_jsx(ICONS.advisor_avn_bell.component, {}), _jsx("div", { className: 'c__recap-header__title', children: "Since you last looked" }), _jsx(ICONS.advisor_avn_close.component, { onClick: Dialog_Recap.hide })] });
    };
    render_Body = () => {
        return _jsx(AwaitModules, { modules: EncounterFeedItem.modulesToAwait, Component: () => _jsx(Component_RecapBody, {}), customLoader: Component_AdvisorSL_Recap });
    };
}
class Component_RecapBody extends ComponentSync {
    // ######################## Life Cycle ########################
    __onRecapFeedUpdated = () => {
        this.setState({ feedItems: ModuleFE_Recap.getFeedItems() });
    };
    deriveStateFromProps(nextProps, state) {
        state.feedItems ??= ModuleFE_Recap.getFeedItems();
        return state;
    }
    // ######################## Logic ########################
    // ######################## Render ########################
    render() {
        return _jsx(FadeScrollWrapper, { className: 'c__recap-body', children: _jsx(Component_EncounterFeed, { feedItems: this.state.feedItems, customEmptyFeedMessage: 'No events to show, you are up to date!', renderContext: 'recap', onItemClick: () => Dialog_Recap.hide() }) });
    }
}
//# sourceMappingURL=Dialog_Recap.js.map